const avatarTableActions = {
  photo: 'FOTO'
};

export default avatarTableActions;
